<template>
  <Tabs v-model="value" :items="items" theme="border" class="dashboard-units" force-header>
    <template v-slot:[value]>
      <component :is="settings.component" />
    </template>
  </Tabs>
</template>

<script>
import { mapState } from 'vuex'
import StorageMixin from '@/mixins/Storage'
import Bus from '@/bus'

import Residentials from '@/components/Project/Residentials'
import { ChoiceComponent } from 'vue-elder-choice'
import Shops from '@/components/Project/Shops'
import Tabs from '@/components/Tabs'

export default {
  mixins: [
    StorageMixin({
      target: 'value',
      async key() {
        await this.promises.fetchOne
        return `project:dashboard:units:${this.item.id}`
      },
      storage: 'localStorage',
    }),
  ],
  props: {
    addons: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value: {
      handler: 'validateValue',
      immediate: true,
    },
    item: {
      handler: 'validateValue',
      immediate: true,
    },
  },
  data() {
    return {
      value: 'units',
    }
  },
  computed: {
    ...mapState('Project', ['item', 'promises']),
    settings() {
      switch (this.value) {
        case 'shops':
          return {
            component: Shops,
          }
        default:
          return {
            component: Residentials,
          }
      }
    },
    items() {
      return [
        {
          id: 'units',
          label: this.$tc('unit', 2),
          condition: this.$store.getters['Project/hasRole']([
            'manager',
            'salesman',
            'signingAuthority',
            'complaint.manager',
          ]),
        },
        {
          id: 'shops',
          label: this.$tc('shop', 2),
          condition: this.$store.getters['Project/hasRole'](/^shop/) && this.addons.includes('project:shop'),
        },
      ].filter(item => !('condition' in item) || item.condition)
    },
  },
  methods: {
    validateValue() {
      if (!['units', 'shops'].includes(this.value)) return (this.value = 'units')
      let unitCheck = this.$store.getters['Project/hasRole']([
        'manager',
        'salesman',
        'signingAuthority',
        'complaint.manager',
      ])
      let shopCheck = this.$store.getters['Project/hasRole'](/^shop\./)

      if (!unitCheck && !shopCheck) return (this.value = 'units')

      if (!this.item.id) return
      if (this.value === 'units' && !unitCheck) return (this.value = 'shops')
      if (this.value === 'shops' && !shopCheck) return (this.value = 'units')
    },
  },
  created() {
    Bus.$on('tab:set', tab => {
      this.value = tab
    })
  },
  components: {
    Residentials,
    Shops,
    ChoiceComponent,
    Tabs,
  },
}
</script>

<style lang="scss">
.dashboard-units {
  .elder-choices {
    margin-bottom: 0rem;
    &__item {
      flex-grow: 0;
      &-label {
        font-size: 0.9em;
        padding: 0.4rem 1rem;
      }
    }
  }
}
</style>
